<template>
    <div class="l-main l-container">
        <div class="l-content__block p-index__sale">
            <div class="c-block__headings">
                <h2 class="">イベント情報</h2>
                <div v-if="isMore" class="c-btn-detail"><a :href="route(route_list, 'site.event.important')">もっと見る</a></div>
            </div>
            <div class="">
                <div v-if="event1" class="event l-container">
                    <dl>
                        <dt>{{ event1.date }}</dt>
                        <dd><a :href="event1.url" id="event-001"><span>{{ event1.title }}</span></a></dd>
                    </dl>
                </div>
                <div v-if="event2"  class="event l-container">
                    <dl>
                        <dt>{{ event2.date }}</dt>
                        <dd><a :href="event2.url" id="event-002"><span>{{ event2.title }}</span></a></dd>
                    </dl>
                </div>
                <div v-if="event3"  class="event l-container">
                    <dl>
                        <dt>{{ event3.date }}</dt>
                        <dd><a :href="event3.url" id="event-003"><span>{{ event3.title }}</span></a></dd>
                    </dl>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import routeMixin from '../../mixins/route.js';
export default {
    props:[
        'route_list',
        'importantEvents',
    ],
    mixins: [routeMixin],
    data() {
        return {
            // TOPページに表示するTOPページ上部イベント情報(公開日最新1件)
            event1: this.importantEvents[0],
            event2: this.importantEvents[1],
            event3: this.importantEvents[2],
            // TOPページ上部イベント情報が3件以上あるか？
            isMore: (this.importantEvents.length > 3) ? true : false,
        }
    }
}
</script>

<style lang="scss" scoped>
.event {
    margin-bottom: 1em;
    &:last-child{
      margin-bottom: 0em;
    }
}
.event dl {
    text-align: left;
    dt {
        color: #9e9e9e;
        font-size: 13px;
    }
    dd {
        font-size: 15px;
        line-height: 1.5;
        a {
            text-decoration-line: underline;
            color: var(--gj-color-blue-2)

        }
    }
}
.event dl + dl {
    margin-top: 3em;
}

@media (min-width:768px){
    .c-btn-detail {
        a {
            color: #000;
        }
    }
    .l-container {
        justify-content: center;
    }
    .event {
        max-width: 920px;
    }
    .event dl {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        dt {
            width: 120px;
        }
        dd {
            a {
                width: 800px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
}

@media (max-width:767px) {
    .event dl {
        display: block;
        dt {
            margin-bottom: .5em;
        }
    }
}
</style>
